import { render, staticRenderFns } from "./WizardContentClaioImageSelector.vue?vue&type=template&id=54791426&scoped=true&"
import script from "./WizardContentClaioImageSelector.vue?vue&type=script&lang=ts&"
export * from "./WizardContentClaioImageSelector.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentClaioImageSelector.vue?vue&type=style&index=0&id=54791426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54791426",
  null
  
)

export default component.exports